const getBaseWithRoot = basename => {
  const port = window.location.port ? `:${window.location.port}` : '';
  const { protocol, hostname } = window.location;
  const root = basename ? `/${basename}` : '';

  return `${protocol}//${hostname}${port}${root}`;
};

const getBase = () => {
  const port = window.location.port ? `:${window.location.port}` : '';
  const { protocol, hostname } = window.location;

  return `${protocol}//${hostname}${port}`;
};

export { getBaseWithRoot, getBase };
